<template>
  <div :class="['detail-panel', { 'detail-panel--visible': isPanelDisplayed }]">
    <div :class="'detail-panel__close'" @click="closePanel">
      <icon-cross :color="iconColor" />
    </div>
    <slot name="content" />
  </div>
</template>

<script setup>
import IconCross from '@/components/icons/IconCross/IconCross.vue'
import { storeToRefs } from 'pinia'
import useDetailPanelStore from '@/stores/detailPanel'

const detailPanelStore = useDetailPanelStore()
const { isPanelDisplayed } = storeToRefs(detailPanelStore)
const { closePanel } = detailPanelStore

const iconColor = getComputedStyle(document.documentElement).getPropertyValue(
  '--primary',
)
</script>

<style lang="scss" scoped>
.detail-panel {
  position: absolute;
  right: 10px;
  bottom: 10px;
  z-index: 1030;
  height: calc(100% - 200px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transform: translate3d(1090px, 0px, 0px);

  transition: 500ms ease-in-out;
}

.detail-panel--visible {
  transform: translate3d(0px, 0px, 0px);
}

.detail-panel__close {
  position: absolute;
  right: 15px;
  top: 15px;
  z-index: 100;
  width: 14px;
  height: 14px;
  border-radius: 12px;
  padding: 10px;

  display: flex;
  justify-content: center;
  align-items: center;

  background: var(--panel-background);
  backdrop-filter: var(--panel-backdrop);
  cursor: pointer;

  box-shadow: var(--panel-shadow);
}

.detail-panel__close:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  background-color: color-mix(in srgb, var(--primary), transparent 70%);
}
</style>
